export class Timer{
    constructor(
        public Token?:string
    ){
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/timer/timer_entity.ts